import { Grid2 } from '@mui/material';
import React from 'react';

const gradientSx = { bgcolor: '#FFFFFF', borderRadius: '100%',
  filter: 'blur(54px)',
  background: 'linear-gradient(180deg, #F09A59, #A541DF, #399FC5)',
  opacity: 0.17 
};


interface AiGradientProps {
  height?: string | null;
  width?: string | null;
}

const AiGradient: React.FC<AiGradientProps> = ({
  height = '600px',
  width = '600px'
}) => {

  return (
    <>
      <Grid2
        display="flex"
        alignItems="center"
        gap={1}
        justifyContent="center"
        flexDirection="column"
        size={12}
        {...(height ? { height } : {})}
        {...(width ? { width } : {})}
        sx={gradientSx}
      />
    </>
  );
};
  
export default AiGradient;